export default "__VITE_ASSET__TPNVFXO4__"